__turbopack_context__.v({
  "bannerWrapper": "_42jjBW_bannerWrapper",
});
